//进货单主表表头信息
export const insheetcolumns = [
  {
    field: "checkbox",
    key: "checkbox",
    title: "",
    type: "checkbox",
    width: "5%",
    align: "center",
    fixed: "left"
    // renderBodyCell: ({ row, column, rowIndex }, h) => {
    //   return ++rowIndex;
    // }
  },
  {
    field: "row",
    key: "row",
    title: "",
    width: "5%",
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey;
    }
  },
  {
    field: "barcode",
    key: "barcode",
    title: "商品条码",
    align: "left",
    width: "12%",
    fixed: "left",
    edit: true,
    sortBy: "",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_name",
    key: "item_name",
    title: "商品名称",
    align: "left",
    width: "20%",
    edit: true,
    sortBy: "",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "class_no",
    key: "class_no",
    title: "类别",
    align: "left",
    width: "15%",
    edit: true

    /* <wty-select
                  id="1"
                  :width="150"
                  :size="'mini'"
                  :who="'branch'"
                  ref="wtySelectRef"
                  @getReturn="wtySelectGetReturn"
                ></wty-select> */
    /*  renderBodyCell: ({ row, column, rowIndex }, h) => {
      return h("wty-select", {
        props: {
          width: "150",
          size:"mini",
          value: row.class_no,
          who:"offlineclass"
        },
        on: {
          input: function(val) {
            console.log(val);
            row.class_no = val;
          }
        }
      });
    }, */
  },
  {
    field: "production_day",
    key: "production_day",
    title: "生产日期",
    align: "left",
    width: "15%",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return h("el-date-picker", {
        props: {
          size: "mini",
          value: row.production_day
        },
        on: {
          input: function(val) {
            row.production_day = val;
          }
        }
      });
    },

    ellipsis: {
      showTitle: true
    }
  },
  /* {
    field: "sup_price",
    key: "sup_price",
    title: "供货价",
    align: "left",
    width: "10%",
    edit: false
  },
  {
    field: "sup_qty",
    key: "sup_qty",
    title: "供货数量",
    align: "left",
    width: "10%",
    edit: false
  }, 
  {
    field: "advise_price",
    key: "advise_price",
    title: "建议售价",
    align: "left",
    width: "10%",
    edit: true
  },*/
  {
    field: "in_price",
    key: "in_price",
    title: "进价",
    align: "left",
    width: "8%",
    fixed: "right",
    edit: true
  },
  {
    field: "qty",
    key: "qty",
    title: "数量",
    align: "left",
    width: "8%",
    fixed: "right",
    edit: true
  },
  {
    field: "buyer_sale_price",
    key: "buyer_sale_price",
    title: "售价",
    align: "left",
    width: "8%",
    fixed: "right",

    edit: true
  },
  {
    field: "profit",
    key: "profit",
    title: "利润",
    align: "left",
    width: "10%",
    fixed: "right",

    edit: false
  },
  {
    field: "stock",
    key: "stock",
    title: "库存",
    align: "left",
    width: "10%",
    fixed: "right",

    edit: false
  },
  {
    field: "money",
    key: "money",
    title: "金额",
    align: "left",
    width: "8%",
    fixed: "right",
    edit: true
  }
];

//出库单主表表头信息
export const outsheetcolumns = [
  {
    field: "checkbox",
    key: "checkbox",
    title: "",
    type: "checkbox",
    width: "5%",
    align: "center",
    fixed: "left"
    // renderBodyCell: ({ row, column, rowIndex }, h) => {
    //   return ++rowIndex;
    // }
  },
  {
    field: "row",
    key: "row",
    title: "",
    width: "5%",
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey;
    }
  },
  {
    field: "barcode",
    key: "barcode",
    title: "商品条码",
    align: "left",
    width: "12%",
    fixed: "left",
    edit: true,
    sortBy: "",

    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_name",
    key: "item_name",
    title: "商品名称",
    align: "left",
    width: "12%",
    sortBy: "",

    ellipsis: {
      showTitle: true
    }
  },
  /* {
    field: "class_no",
    key: "class_no",
    title: "类别",
    align: "left",
    width: "10%",
    ellipsis: {
      showTitle: true
    }
  }, */
  {
    field: "production_day",
    key: "production_day",
    title: "生产日期",
    align: "left",
    width: "12%",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return h("el-date-picker", {
        props: {
          size: "mini",
          value: row.production_day
        },
        on: {
          input: function(val) {
            row.production_day = val;
          }
        }
      });
    },
    ellipsis: {
      showTitle: true
    }
  },
  /* {
    field: "buyer_price",
    key: "buyer_price",
    title: "购买方进价",
    align: "left",
    width: "10%",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "buyer_qty",
    key: "buyer_qty",
    title: "购买方数量",
    align: "left",
    width: "10%",
    ellipsis: {
      showTitle: true
    }
  }, */
  /* {
    field: "advise_price",
    key: "advise_price",
    title: "建议售价",
    align: "left",
    width: "10%",
    edit: true
  }, */
  {
    field: "sale_price",
    key: "sale_price",
    title: "售价（出库价）",
    align: "left",
    width: "10%",
    fixed: "right",
    edit: true
  },
  {
    field: "qty",
    key: "qty",
    title: "数量",
    align: "left",
    width: "10%",
    fixed: "right",

    edit: true
  },

  {
    field: "money",
    key: "money",
    title: "金额",
    align: "left",
    width: "10%",
    fixed: "right",
    edit: true
  }
];

//选择框表头信息
export const selectBoxcolumns = [
  {
    field: "",
    key: "b",
    title: "",
    type: "checkbox",
    width: "10%",
    align: "center",
    fixed: "left"
  },
  {
    field: "",
    key: "a",
    title: "",
    width: "10%",
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey;
    }
  },
  {
    field: "barcode",
    key: "barcode",
    title: "商品条码",
    align: "left",
    width: "30%",
    fixed: "left",
    edit: true,
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_name",
    key: "item_name",
    title: "商品名称",
    align: "left",
    width: "30%",
    edit: true,
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_size",
    key: "item_size",
    title: "规格",
    align: "left",
    width: "20%",
    edit: true
  }
];
//选择框表头信息
export const radioBoxcolumns = [
  {
    field: "",
    key: "b",
    title: "",
    type: "radio",
    width: "10%",
    align: "center",
    fixed: "left"
  },
  {
    field: "",
    key: "a",
    title: "",
    width: "10%",
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey;
    }
  },
  {
    field: "item_no",
    key: "item_no",
    title: "货号",
    align: "left",
    width: "20%",
    fixed: "left",
    edit: true,
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "barcode",
    key: "barcode",
    title: "商品条码",
    align: "left",
    width: "20%",
    fixed: "left",
    edit: true,
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_name",
    key: "item_name",
    title: "商品名称",
    align: "left",
    width: "20%",
    edit: true,
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "item_size",
    key: "item_size",
    title: "规格",
    align: "left",
    width: "20%",
    edit: true
  }
];

//选择单据信息
export const selectSheetColumns = [
  {
    field: "",
    key: "b",
    title: "",
    type: "radio",
    width: "5%",
    align: "center",
    fixed: "left"
  },
  {
    field: "",
    key: "a",
    title: "",
    width: "5%",
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey;
    }
  },
  {
    field: "mch_name",
    key: "mch_name",
    title: "店铺",
    align: "left",
    width: "15%",
    fixed: "left",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "other_mch_name",
    key: "other_mch_name",
    title: "对方店铺",
    align: "left",
    width: "15%",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "approve",
    key: "approve",
    title: "是否审核",
    align: "left",
    width: "10%"
  },
  {
    field: "total_amount",
    key: "total_amount",
    title: "合计金额",
    align: "left",
    width: "15%"
  },
  {
    field: "create_time",
    key: "create_time",
    title: "创建时间",
    align: "left",
    width: "20%"
  }
];

//商品基本信息表头
export const goodsInfoColumns = [
  // 标题第一列
  {
    field: "",
    key: "b",
    title: "",
    type: "checkbox",
    width: 50,
    align: "center",
    fixed: "left"
    // renderBodyCell: ({ row, column, rowIndex }, h) => {
    //   return ++rowIndex;
    // }
  },
  {
    field: "index",
    key: "a",
    title: "行号",
    width: 80,
    align: "center",
    renderBodyCell: ({ row, column, rowIndex }, h) => {
      return row.rowKey + 1;
    },
    sortBy: ""
  },

  // 表头信息
  {
    field: "barcode",
    key: "barcode",
    title: "商品条码",
    align: "left",
    width: 150,
    edit: true,
    fixed: "left",
    sortBy: ""
  },
  {
    field: "item_name",
    key: "item_name",
    title: "商品名称",
    align: "left",
    width: 250,
    edit: true,
    fixed: "left",
    ellipsis: {
      showTitle: true
    }
  },
  {
    field: "class_no",
    key: "class_no",
    title: "类别",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "advise_price",
    key: "advise_price",
    title: "建议售价",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "brand_name",
    key: "brand_name",
    title: "品牌",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "product_area",
    key: "product_area",
    title: "产地",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "unit",
    key: "unit",
    title: "单位",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "item_size",
    key: "item_size",
    title: "规格",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "grade",
    key: "grade",
    title: "等级",
    align: "left",
    width: 100,
    edit: true
  },
  {
    field: "life_day",
    key: "life_day",
    title: "保质期（天）",
    align: "left",
    width: 150,
    edit: true
  },
  {
    field: "weight_flag",
    key: "weight_flag",
    title: "称重标识",
    align: "left",
    width: 100,
    edit: true
  }
];

//单元格样式
export const cellStyleOption = {
  bodyCellClass: ({ row, column, rowIndex }) => {
    if (row.class_state != 0) {
      switch (row.class_state) {
        case "1":
          return "table-body-cell-goods-not";
        case "2":
          return "table-body-cell-inprice-low";
        case "3":
          return "table-body-cell-inprice-high";
        case "4":
          return "table-body-cell-goods-delete";
        case "5":
          return "table-body-cell-goods-offline-not";
        case "6":
          return "table-body-cell-goods-offin-not";
        case "7":
          return "table-body-cell-goods-offline-hive";
        case "8":
          return "table-body-cell-goods-approve";
        case "9":
          return "table-body-cell-goods-unapprove";
      }
    } else if (row.rowKey % 2 == 0) {
      return "table-body-cell-goods-even";
    }
  }
};

//选择框的值
export const goodsSelectColumn = [
  {
    label: "建议售价",
    value: "advise_price"
  },
  {
    label: "类别",
    value: "class_no"
  },
  {
    label: "规格",
    value: "item_size"
  },
  {
    label: "品牌",
    value: "brand_name"
  },
  {
    label: "产地",
    value: "product_area"
  },
  {
    label: "单位",
    value: "unit"
  },
  {
    label: "等级",
    value: "grade"
  },
  {
    label: "保质期（天）",
    value: "life_day"
  },
  {
    label: "称重标识",
    value: "weight_flag"
  }
];


